/// <amd-module name="SuiteCommerce.FeaturedCategory.Button.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.FeaturedCategory.Button.View", ["require", "exports", "Backbone", "sc_featuredcategory_button.tpl"], function (require, exports, Backbone_1, featuredCategoryButtonTemplate) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ButtonView = void 0;
    var ButtonView = /** @class */ (function (_super) {
        __extends(ButtonView, _super);
        function ButtonView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = featuredCategoryButtonTemplate;
            _this.model.on('reset sync add remove change destroy', function () {
                _this.render();
            });
            return _this;
        }
        ButtonView.prototype.getContext = function () {
            var buttonText = this.model.buttonText;
            var buttonLink = this.model.customUrl ? this.model.customUrl : this.model.fullurl;
            return {
                buttonText: buttonText,
                buttonLink: buttonLink,
                buttonStyle: this.model.buttonStyle,
                showButton: !!buttonText && !!buttonLink,
            };
        };
        return ButtonView;
    }(Backbone_1.View));
    exports.ButtonView = ButtonView;
});
